import Button from '@material-ui/core/Button';
import { styled } from '@material-ui/core/styles';

export const StyledButton = styled(Button)({
  whiteSpace: 'nowrap'
});
